import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=6026f487&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.103.0_@swc+core_f91a0a1053829af0a77e207d835d75dd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026f487",
  null
  
)

export default component.exports